// Oferta "Levar outro" no carrinho: junta um segundo artigo com a MESMA personalização
// e aplica o desconto de 50% na segunda unidade.
//
// ⚠️ Tem de ser um ficheiro do tema carregado no layout. Quando a gaveta do carrinho é
// redesenhada por JavaScript, os <script> que vêm nesse HTML NÃO são executados pelo browser.
// Era essa a razão de o botão não fazer nada para quem chegava ao site com o carrinho vazio.

(function () {
  if (window.__levarOutroLigado) return;
  window.__levarOutroLigado = true;

  const CODIGO = 'LEVAOUTRO50'; // Bxgy: compra 1, leva o 2º a 50%
  // O desconto é o código Bxgy da loja. (Se um dia entrar uma app de descontos por quantidade,
  // pôr isto a false: o desconto passa a ser dela, automático e por produto.)
  const USAR_CODIGO = true;

  const raiz = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const gaveta = () => document.querySelector('cart-drawer');
  const retrato = () => {
    const artigos = document.querySelectorAll('cart-drawer .cart-item').length;
    const soma = [...document.querySelectorAll('cart-drawer .quantity__input')]
      .reduce((t, c) => t + (Number(c.value) || 0), 0);
    return artigos + ':' + soma;
  };

  // O tema redesenha a gaveta a seguir a qualquer pedido ao carrinho e apagava a mensagem.
  // Por isso o aviso vive fora do carrinho, colado ao ecrã, e desaparece sozinho.
  let temporizador = null;
  const avisar = (texto) => {
    let caixa = document.querySelector('.levar-outro-aviso');
    if (!caixa) {
      caixa = document.createElement('div');
      caixa.className = 'levar-outro-aviso';
      caixa.setAttribute('role', 'status');
      document.body.appendChild(caixa);
    }
    caixa.textContent = texto;
    caixa.classList.add('levar-outro-aviso--visivel');
    clearTimeout(temporizador);
    temporizador = setTimeout(() => caixa.classList.remove('levar-outro-aviso--visivel'), 6000);
  };

  // mensagens nossas, em português: as do Shopify vêm em inglês
  const mensagemDeErro = (estado, descricao) => {
    if (estado === 422) {
      return /quantidade|carrinho/i.test(descricao || '')
        ? 'Já não há stock para juntar outro. Experimenta outro tamanho.'
        : 'Já não há stock para juntar outro.';
    }
    return 'Não conseguimos juntar agora. Tenta outra vez daqui a pouco.';
  };

  // que código está aplicado agora? (o Shopify só aceita um de cada vez)
  const codigoActual = async () => {
    try {
      const c = await (await fetch(raiz() + 'cart.js')).json();
      const aplicado = (c.discount_codes || []).filter((d) => d.applicable !== false).map((d) => d.code);
      return aplicado.find((c2) => c2.toUpperCase() !== CODIGO) || null;
    } catch (e) {
      return null;
    }
  };

  const seccoesDoCarrinho = () => {
    try {
      const g = gaveta();
      if (g && g.getSectionsToRender) return g.getSectionsToRender().map((s) => s.id);
    } catch (e) {}
    return ['cart-drawer', 'cart-icon-bubble'];
  };

  // desenha de novo o carrinho: primeiro pelo tema, depois por nós, e em último caso recarrega
  const redesenhar = async (dados, antes) => {
    try {
      const g = gaveta();
      if (g && g.renderContents) g.renderContents(dados);
    } catch (e) {}
    await new Promise((r) => setTimeout(r, 400));

    if (retrato() === antes) {
      const html = dados && dados.sections && dados.sections['cart-drawer'];
      const destino = gaveta();
      const origem = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer') : null;
      if (origem && destino) destino.innerHTML = origem.innerHTML;
      else return false;
    }

    const g = gaveta();
    if (g) {
      g.classList.add('active');
      try {
        if (g.open) g.open();
      } catch (e) {}
    }
    return true;
  };



  // ---- Personalização em falta logo a seguir a adicionar ----
  // A app escreve as propriedades no carrinho com um atraso de 1-2 segundos. Como a gaveta abre
  // logo a seguir ao "Adicionar ao carrinho", ficava a mostrar meia dúzia de campos e só depois
  // de recarregar a página é que aparecia tudo. Aqui contamos o que devia estar à vista e, se
  // faltar alguma coisa, pedimos o carrinho outra vez.
  const camposEsperados = (linha) =>
    Object.entries(linha.properties || {}).filter(([chave, valor]) => {
      if (!chave || chave.charAt(0) === '_') return false;
      const v = String(valor == null ? '' : valor).trim();
      if (v === '' || v === 'Não' || v === 'No') return false;
      return chave.indexOf('Confirmo') === -1;
    }).length;

  let ultimaConferencia = 0;
  const conferirPersonalizacao = async () => {
    const agora = Date.now();
    if (agora - ultimaConferencia < 3000) return;
    ultimaConferencia = agora;
    try {
      const c = await (await fetch(raiz() + 'cart.js')).json();
      const esperado = c.items.reduce((t, l) => t + camposEsperados(l), 0);
      const mostrado = document.querySelectorAll('cart-drawer .cart-item dl dt').length;
      if (mostrado < esperado) await redesenharCarrinho();
    } catch (e) {}
  };

  // ao abrir a gaveta (é quando o problema se vê), conferir daqui a pouco
  const vigiarAbertura = () => {
    const g = gaveta();
    if (!g || g.dataset.levarOutroVigiado) return;
    g.dataset.levarOutroVigiado = '1';
    new MutationObserver(() => {
      if (g.classList.contains('active')) {
        actualizarCache();
        setTimeout(reconciliar, 300);
        setTimeout(conferirPersonalizacao, 1500);
        setTimeout(conferirPersonalizacao, 3500);
      }
    }).observe(g, { attributes: true, attributeFilter: ['class'] });
  };
  vigiarAbertura();
  new MutationObserver(vigiarAbertura).observe(document.documentElement, { childList: true, subtree: true });


  const chaveDeGrupo = (linha) => {
    const p = linha.properties || {};
    return p['_customily-upsell-main-id'] || p['_gpo_product_group'] || null;
  };
  const chaveDeExtra = (linha) => {
    const p = linha.properties || {};
    return p['_customily-upsell-id'] || p['_gpo_parent_product_group'] || null;
  };

  // ---- Apagar de uma só vez ----
  // Se deixarmos o tema apagar só a linha e corrigirmos os extras a seguir, o cliente vê o preço
  // acertar duas vezes. Com uma cópia do carrinho em memória sabemos logo o que apagar e fazemos
  // tudo num pedido só. Se a cópia estiver velha, deixamos o tema fazer e corrigimos depois.
  let cacheCarrinho = null;
  const actualizarCache = async () => {
    try {
      cacheCarrinho = await (await fetch(raiz() + 'cart.js')).json();
    } catch (e) {
      cacheCarrinho = null;
    }
  };

  const renderizar = (dados) => {
    const g = gaveta();
    const estavaAberta = !!(g && g.classList.contains('active'));
    try {
      if (g && g.renderContents) g.renderContents(dados);
    } catch (e) {}
    const g2 = gaveta();
    if (g2 && !estavaAberta) g2.classList.remove('active');
  };

  document.addEventListener('click', (evento) => {
    const botao = evento.target.closest('cart-drawer cart-remove-button');
    if (!botao || !cacheCarrinho) return;
    const indice = Number(botao.dataset.index || botao.getAttribute('data-index'));
    const linha = cacheCarrinho.items[indice - 1];
    if (!linha || chaveDeExtra(linha)) return;            // não é um artigo principal
    // se a cópia estiver desactualizada, não arriscamos: o tema apaga e nós corrigimos a seguir
    const handleBotao = botao.dataset.handle || botao.getAttribute('data-handle');
    if (handleBotao && linha.handle && handleBotao !== linha.handle) return;
    const chave = chaveDeGrupo(linha);
    if (!chave) return;                                   // sem extras: o tema trata disto bem

    const unidadesDepois =
      cacheCarrinho.items
        .filter((l) => chaveDeGrupo(l) === chave && !chaveDeExtra(l))
        .reduce((t, l) => t + l.quantity, 0) - linha.quantity;

    const updates = { [linha.key]: 0 };
    for (const l of cacheCarrinho.items) {
      if (chaveDeExtra(l) !== chave) continue;
      const multiplicador = Number((l.properties || {})['_customily-upsell-multiplier'] || 1) || 1;
      updates[l.key] = Math.max(0, unidadesDepois) * multiplicador;
    }

    evento.preventDefault();
    evento.stopPropagation();
    if (evento.stopImmediatePropagation) evento.stopImmediatePropagation();

    (async () => {
      try {
        const r = await fetch(raiz() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: seccoesDoCarrinho(), sections_url: window.location.pathname }),
        });
        if (!r.ok) throw new Error('falhou');
        renderizar(await r.json());
        window.__levarOutroApagouRapido = (window.__levarOutroApagouRapido || 0) + 1;
        await actualizarCache();
      } catch (e) {
        window.location.reload();
      }
    })();
  }, true);

  // ---- Reconciliação do carrinho ----
  // Os extras (base, adaptador, gravação) são linhas escondidas ligadas ao artigo por uma chave.
  // Se o cliente apagar ou baixar a quantidade do artigo, essas linhas podem ficar órfãs: ele
  // continuava a pagá-las sem as ver, e o preço da linha que sobra aparecia inflacionado.
  // Aqui garantimos que cada grupo tem tantos extras quantas as unidades do artigo principal.
  let aReconciliar = false;
  // Um só pedido: corrige as quantidades E traz o carrinho já redesenhado. Antes eram três ou
  // quatro pedidos seguidos e o preço demorava a acertar à vista.
  const reconciliar = async () => {
    if (aReconciliar) return false;
    aReconciliar = true;
    try {
      const c = await (await fetch(raiz() + 'cart.js')).json();
      const unidadesPorGrupo = {};
      for (const linha of c.items) {
        const chave = chaveDeGrupo(linha);
        if (chave && !chaveDeExtra(linha)) unidadesPorGrupo[chave] = (unidadesPorGrupo[chave] || 0) + linha.quantity;
      }
      const correccoes = {};
      let ha = false;
      for (const linha of c.items) {
        const chave = chaveDeExtra(linha);
        if (!chave) continue;
        const multiplicador = Number((linha.properties || {})['_customily-upsell-multiplier'] || 1) || 1;
        const alvo = (unidadesPorGrupo[chave] || 0) * multiplicador;
        if (linha.quantity !== alvo) { correccoes[linha.key] = alvo; ha = true; }
      }

      // O código fica guardado na sessão e o Shopify volta a aplicá-lo sozinho assim que o
      // carrinho fica elegível — mesmo com DUAS PERSONALIZAÇÕES DIFERENTES, que não é a oferta.
      // Só o deixamos ficar quando existem mesmo duas unidades da MESMA personalização, ou seja
      // linhas com as mesmas propriedades todas (é isso que distingue a cópia de outro presente).
      // Assinatura do DESENHO: o mesmo produto com a mesma personalização, mesmo que a segunda
      // peça seja noutro tamanho (roupa) e mesmo que tenhamos mudado a chave de grupo na cópia.
      // Por isso ignoram-se as chaves técnicas de agrupamento e o tamanho/variante.
      const CHAVES_TECNICAS = ['_gpo_product_group', '_customily-upsell-main-id'];
      const assinatura = (linha) => {
        const props = linha.properties || {};
        const chaves = Object.keys(props)
          .filter((k) => CHAVES_TECNICAS.indexOf(k) === -1)
          .sort();
        return linha.product_id + '|' + chaves.map((k) => k + '=' + props[k]).join('§');
      };
      const unidadesPorPersonalizacao = {};
      for (const linha of c.items) {
        if (chaveDeExtra(linha)) continue;
        const a = assinatura(linha);
        unidadesPorPersonalizacao[a] = (unidadesPorPersonalizacao[a] || 0) + linha.quantity;
      }
      const haSegundaIgual = Object.values(unidadesPorPersonalizacao).some((n) => n >= 2);
      const nossoCodigoActivo = (c.discount_codes || []).some(
        (d) => d.applicable !== false && String(d.code).toUpperCase() === CODIGO
      );
      // O contrário também: se o cliente chegar a duas unidades iguais pelo botão "+" do carrinho,
      // merece o mesmo desconto que teria pela oferta. Só não mexemos se ele tiver um código dele.
      const outroCodigo = (c.discount_codes || []).some(
        (d) => d.applicable !== false && String(d.code).toUpperCase() !== CODIGO
      );
      if (USAR_CODIGO && !nossoCodigoActivo && haSegundaIgual && !outroCodigo) {
        try {
          await fetch(raiz() + 'discount/' + CODIGO, { method: 'GET' });
          const r1 = await fetch(raiz() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: {}, sections: seccoesDoCarrinho(), sections_url: window.location.pathname }),
          });
          if (r1.ok) {
            renderizar(await r1.json());
            if (!ha) return true;
          }
        } catch (e) {}
      }

      if (USAR_CODIGO && nossoCodigoActivo && !haSegundaIgual) {
        const r0 = await fetch(raiz() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '', sections: seccoesDoCarrinho(), sections_url: window.location.pathname }),
        });
        if (r0.ok) {
          renderizar(await r0.json());
          if (!ha) return true;
        }
      }

      if (!ha) return false;

      const r = await fetch(raiz() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: correccoes, sections: seccoesDoCarrinho(), sections_url: window.location.pathname }),
      });
      if (!r.ok) return false;
      const dados = await r.json();
      const g = gaveta();
      const estavaAberta = !!(g && g.classList.contains('active'));
      try {
        if (g && g.renderContents) g.renderContents(dados);
      } catch (e) {}
      const g2 = gaveta();
      if (g2 && !estavaAberta) g2.classList.remove('active');
      return true;
    } catch (e) {
      return false;
    } finally {
      aReconciliar = false;
    }
  };

  const redesenharCarrinho = async () => {
    try {
      const r = await fetch(raiz() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: {}, sections: seccoesDoCarrinho(), sections_url: window.location.pathname }),
      });
      if (!r.ok) return;
      const dados = await r.json();
      const g = gaveta();
      const aberta = !!(g && g.classList.contains('active'));
      if (g && g.renderContents) g.renderContents(dados);
      if (!aberta && g) g.classList.remove('active');
    } catch (e) {}
  };

  // depois de o cliente mexer no carrinho (apagar, +, -), arrumar os extras
  document.addEventListener('click', (evento) => {
    if (!evento.target.closest('cart-drawer cart-remove-button, cart-drawer .quantity__button')) return;
    setTimeout(async () => { await reconciliar(); await actualizarCache(); }, 450);
    setTimeout(async () => { await reconciliar(); await actualizarCache(); }, 1600);
  }, true);
  document.addEventListener('change', (evento) => {
    if (!evento.target.closest('cart-drawer .quantity__input')) return;
    setTimeout(reconciliar, 450);
    setTimeout(reconciliar, 1600);
  }, true);

  // Nas caixas de tamanhos, deixar escolhido um tamanho diferente do que já está no carrinho:
  // a graça da oferta é levar outro tamanho, e cada tamanho costuma ter uma unidade em stock.
  // O marcador "pronto" garante que só mexemos uma vez e nunca por cima da escolha do cliente.
  const escolherOutroTamanho = () => {
    document.querySelectorAll('.levar-outro__tamanhos:not([data-pronto])').forEach((caixa) => {
      caixa.dataset.pronto = '1';
      const diferente = [...caixa.options].find((o) => o.dataset.mesmo !== '1');
      if (diferente) caixa.value = diferente.value;
    });
  };
  let agendado = false;
  const agendar = () => {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(() => { agendado = false; escolherOutroTamanho(); });
  };
  agendar();
  document.addEventListener('DOMContentLoaded', agendar);
  // o carrinho é redesenhado muitas vezes: voltar a tratar das caixas novas
  new MutationObserver(agendar).observe(document.documentElement, { childList: true, subtree: true });

  // Fase de captura: o clique chega-nos mesmo que o tema o trave pelo caminho.
  document.addEventListener('click', async (evento) => {
    const botao = evento.target.closest('.levar-outro__botao');
    if (!botao || botao.disabled) return;
    evento.preventDefault();

    const caixa = botao.closest('[data-levar-outro]');
    const tamanhos = caixa ? caixa.querySelector('.levar-outro__tamanhos') : null;
    const id = Number(tamanhos ? tamanhos.value : botao.dataset.variante);

    // o Liquid entrega as propriedades como lista de pares [chave, valor]
    const paresParaObjecto = (cru) => (Array.isArray(cru) ? Object.fromEntries(cru) : cru || {});
    let propriedades = {};
    try {
      propriedades = paresParaObjecto(JSON.parse((caixa && caixa.dataset.props) || '{}'));
    } catch (e) {}

    // Extras (base de apoio, adaptador, frases): a Customily acrescenta-os sozinha à cópia,
    // por isso NÃO os metemos já — ficavam a dobrar. Mas nem todas as apps o fazem, por isso
    // depois de juntar confirmamos e, se faltarem, acrescentamo-los nós.
    let extras = [];
    try {
      extras = JSON.parse((caixa && caixa.dataset.extras) || '[]');
    } catch (e) {}

    const textoOriginal = botao.textContent;
    botao.disabled = true;
    botao.textContent = 'A juntar...';
    const antes = retrato();

    try {
      // 1. Juntar o segundo artigo.
      //    Quando é o MESMO artigo, aumenta-se a quantidade da linha em vez de criar outra:
      //    o tema soma os extras por chave de grupo e divide pela quantidade da linha, por isso
      //    duas linhas com a mesma chave faziam o preço aparecer a dobrar (62,50€ em vez de 44,70€).
      const mesmaVariante = id === Number(botao.dataset.variante);
      const chaveLinha = caixa && caixa.dataset.linha;
      const qtdActual = Number((caixa && caixa.dataset.qtd) || 1);
      const alvo = qtdActual + 1;

      if (mesmaVariante && chaveLinha) {
        const r1 = await fetch(raiz() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: chaveLinha, quantity: alvo }),
        });
        if (!r1.ok) {
          const e1 = await r1.json().catch(() => ({}));
          throw new Error(mensagemDeErro(r1.status, e1.description || e1.message));
        }

        // os extras acompanham a quantidade (a app costuma fazê-lo; garantimos o número certo)
        if (extras.length) {
          await new Promise((r) => setTimeout(r, 2500));
          const c = await (await fetch(raiz() + 'cart.js')).json();
          for (const extra of extras) {
            const linha = c.items.find((l) => l.key === extra.chave);
            if (linha && linha.quantity !== alvo) {
              await fetch(raiz() + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: extra.chave, quantity: alvo }),
              }).catch(() => {});
            }
          }
        }
      } else {
        // Roupa noutro tamanho: tem de ser linha nova. Damos-lhe uma chave de grupo própria,
        // senão o tema soma os extras das duas linhas a cada uma delas.
        const marca = '-2';
        const novas = Object.assign({}, propriedades);
        const grupoAntigo = novas['_gpo_product_group'];
        if (grupoAntigo) novas['_gpo_product_group'] = grupoAntigo + marca;
        const upsellAntigo = novas['_customily-upsell-main-id'];
        if (upsellAntigo) novas['_customily-upsell-main-id'] = upsellAntigo + marca;

        const artigos = [{ id: id, quantity: 1, properties: novas }];
        for (const extra of extras) {
          const props = paresParaObjecto(extra.props);
          if (props['_gpo_parent_product_group']) props['_gpo_parent_product_group'] = props['_gpo_parent_product_group'] + marca;
          if (props['_customily-upsell-id']) props['_customily-upsell-id'] = props['_customily-upsell-id'] + marca;
          artigos.push({ id: extra.id, quantity: 1, properties: props });
        }
        const r2 = await fetch(raiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: artigos }),
        });
        if (!r2.ok) {
          const e2 = await r2.json().catch(() => ({}));
          throw new Error(mensagemDeErro(r2.status, e2.description || e2.message));
        }
      }

      // 2. aplicar o desconto da segunda unidade (é o Shopify que risca o preço).
      //    Quase nenhum código da loja combina com descontos de produto, e o Shopify só
      //    aceita um código de cada vez: se havia outro, avisamos que foi substituído.
      let anterior = null;
      if (USAR_CODIGO) {
        anterior = await codigoActual();
        try {
          await fetch(raiz() + 'discount/' + CODIGO, { method: 'GET' });
        } catch (e) {}
      }

      // 3. pedir o carrinho já com o desconto e redesenhar
      const actualizado = await fetch(raiz() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // a marca fica na encomenda: é assim que depois se conta quantas vieram da oferta
        body: JSON.stringify({
          attributes: { 'Leva outro': 'aceite' },
          sections: seccoesDoCarrinho(),
          sections_url: window.location.pathname,
        }),
      });
      const dados = actualizado.ok ? await actualizado.json() : null;
      if (!dados) throw new Error("Não conseguimos actualizar o carrinho. Tenta outra vez.");

      if (!(await redesenhar(dados, antes))) {
        window.location.reload();
        return;
      }
      if (anterior) avisar('Aplicámos os 50% no segundo. Isto substituiu o código ' + anterior + '.');
      await actualizarCache();
    } catch (erro) {
      botao.disabled = false;
      botao.textContent = textoOriginal;
      avisar(erro.message || 'Não conseguimos juntar agora. Tenta outra vez daqui a pouco.');
    }
  }, true);
})();

// ---- Auto-reparação da PÁGINA /cart (07-09-2026) ----
// Sintoma: de vez em quando a página do carrinho fica sem a tabela de artigos (linhas com altura zero)
// e só com o subtotal, sobretudo com roupa: um redesenho por JavaScript (tema Shrine + apps de opções)
// apaga as linhas, embora o servidor as devolva bem. Aqui, sempre que a secção muda, esperamos um pouco
// e, se não houver linhas visíveis mas o carrinho tiver artigos, voltamos a pedir a secção ao Shopify
// e repomo-la. Limitado a 3 reparações por página para nunca entrar em ciclo.
(function () {
  if (window.__repararCarrinhoLigado) return;
  window.__repararCarrinhoLigado = true;
  if (!/^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname)) return;

  const raiz = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let reparacoes = 0;
  let temporizador = null;
  let aReparar = false;

  const linhasVisiveis = () =>
    [...document.querySelectorAll('cart-items form#cart .cart-item')].filter((tr) => tr.offsetHeight > 0).length;

  const reparar = async () => {
    if (aReparar || reparacoes >= 3) return;
    aReparar = true;
    try {
      const carrinho = await (await fetch(raiz() + 'cart.js')).json();
      if (!carrinho.item_count || linhasVisiveis() > 0) return;
      const html = await (await fetch(raiz() + 'cart?section_id=main-cart-items')).text();
      const novo = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
      const actual = document.querySelector('cart-items');
      if (!novo || !actual) return;
      actual.innerHTML = novo.innerHTML;
      reparacoes += 1;
    } catch (e) {
      // sem rede ou sem secção: fica como está
    } finally {
      aReparar = false;
    }
  };

  const agendar = () => {
    clearTimeout(temporizador);
    temporizador = setTimeout(reparar, 700);
  };

  const vigiar = () => {
    const alvo = document.querySelector('cart-items');
    if (!alvo || alvo.dataset.repararVigiado) return;
    alvo.dataset.repararVigiado = '1';
    new MutationObserver(agendar).observe(alvo, { childList: true, subtree: true });
    agendar();
  };
  vigiar();
  new MutationObserver(vigiar).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', agendar);
})();
